import React, { useState, useEffect } from 'react';
import { isBefore, differenceInSeconds } from 'date-fns';

interface CountdownProps {
  deadline: string;
}

const CountdownTimer: React.FC<CountdownProps> = ({ deadline }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTime = () => {
      const now = new Date();
      const end = new Date(deadline);

      if (isBefore(end, now)) {
        setIsExpired(true);
        return;
      }

      // Calculamos la diferencia total en segundos
      const totalSeconds = differenceInSeconds(end, now);

      // Convertimos a días, horas, minutos y segundos manualmente para exactitud total
      const days = Math.floor(totalSeconds / (60 * 60 * 24));
      const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = Math.floor(totalSeconds % 60);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    calculateTime(); // Ejecutar inmediatamente
    const timer = setInterval(calculateTime, 1000);

    return () => clearInterval(timer);
  }, [deadline]);

  if (isExpired) {
    return (
      <div className="countdown-container expired" style={{
        background: '#ffebee',
        padding: '1rem',
        borderRadius: '8px',
        textAlign: 'center',
        marginBottom: '2rem',
        border: '1px solid #ffcdd2',
        color: '#d32f2f',
        fontWeight: 'bold'
      }}>
        INSCRIÇÕES ENCERRADAS
      </div>
    );
  }

  return (
    <div className="countdown-container" style={{
      background: 'var(--accent-color)',
      padding: '1rem',
      borderRadius: '8px',
      textAlign: 'center',
      marginBottom: '2rem',
      border: '1px solid var(--border-color)'
    }}>
      <p style={{ fontSize: '0.85rem', fontWeight: 'bold', marginBottom: '0.8rem', color: 'var(--primary-color)' }}>
        AS INSCRIÇÕES TERMINAM EM:
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', fontSize: '1.5rem', fontWeight: 'bold', color: 'var(--text-dark)' }}>
        <div style={{ minWidth: '60px' }}>
          <span style={{ display: 'block' }}>{timeLeft.days}</span>
          <p style={{ fontSize: '0.65rem', margin: 0, color: 'var(--text-muted)' }}>DIAS</p>
        </div>
        <div style={{ minWidth: '60px' }}>
          <span style={{ display: 'block' }}>{timeLeft.hours.toString().padStart(2, '0')}</span>
          <p style={{ fontSize: '0.65rem', margin: 0, color: 'var(--text-muted)' }}>HORAS</p>
        </div>
        <div style={{ minWidth: '60px' }}>
          <span style={{ display: 'block' }}>{timeLeft.minutes.toString().padStart(2, '0')}</span>
          <p style={{ fontSize: '0.65rem', margin: 0, color: 'var(--text-muted)' }}>MIN</p>
        </div>
        <div style={{ minWidth: '60px' }}>
          <span style={{ display: 'block' }}>{timeLeft.seconds.toString().padStart(2, '0')}</span>
          <p style={{ fontSize: '0.65rem', margin: 0, color: 'var(--text-muted)' }}>SEG</p>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
